import styled from "styled-components";
import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import notificationsServices from "services/notificationsServices";
import jwtDecode from "jwt-decode";
import { useHistory, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
// import { updateNotification } from '../../store/actions/notificationData';
import { Notification } from "types/notificatonTypes";

const Notifications = () => {
  const { t } = useTranslation();
  const token = localStorage.getItem("token");
  const { push } = useHistory();
  const dispatch = useDispatch();
  const history = useHistory();
  const loc = useLocation();
  const isNotificationActive = loc.pathname === "/notifications";

  const [notificationCounter, setNotificationsCounter] = useState("0");
  const isNotificatonNumChange = useSelector((state: any) => state.notificationPageNumberReducer);

  const getNotificationCounter = async () => {
    try {
      const response = await notificationsServices.getNotificationCounter();
      setNotificationsCounter(String(response));
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (!isNotificatonNumChange.notificationCounter) {
      getNotificationCounter();
    }
  }, [isNotificatonNumChange.notificationCounter]);

  const handleButtonClick = () => {
    history.push("/notifications");
  };

  return (
    <>
      <Div
        notificationsNumber={notificationCounter}
        onClick={handleButtonClick}
        active={isNotificationActive}
      >
        <SvgBox active={isNotificationActive}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="17"
            height="17"
            viewBox="0 0 14.385 17"
            onClick={handleButtonClick}
          >
            <path
              id="bell"
              d="M12.817,20.375a1.7,1.7,0,0,0,1.692-1.7H11.125A1.7,1.7,0,0,0,12.817,20.375Zm5.5-5.1V10.6a5.509,5.509,0,0,0-4.231-5.355V4.65a1.269,1.269,0,1,0-2.538,0v.595A5.509,5.509,0,0,0,7.317,10.6v4.675l-1.692,1.7v.85H20.01v-.85Z"
              transform="translate(-5.625 -3.375)"
              fill="#9CB0C4"
            />
          </svg>
        </SvgBox>

        <p
          style={{
            fontSize: "14px",
            color: isNotificationActive ? "#FF9200" : "#9CB0C4",
          }}
        >
          {t("notifications.title")}
        </p>
      </Div>
    </>
  );
};

export default Notifications;

const SvgBox = styled.div<{ active?: boolean }>`
  width: 28px;
  height: 28px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  /* background: ${({ active }) => (active ? "#061c2e" : "#092a44")}; */
  transition: box-shadow 0.2s, transform 0.2s, background 0.2s;
  /* border: ${({ active }) => (active ? "1px solid #FF9200" : "")}; */
  /* transform: ${({ active }) => (active ? "translateY(2px) scale(0.97)" : "none")}; */

  ${({ active }) =>
    !active &&
    `
      &:hover {
        // box-shadow: 0 0 8px 2px orange;
        // border: 1px solid #9CB0C4;

      }
    `}
`;

export const Div = styled.div<{
  notificationsNumber?: string;
  active?: boolean;
}>`
  /* width: 100px !important; */
  position: relative;
  display: flex;
  align-items: center;
  cursor: ${({ active }) => (active ? "default" : "pointer")};
  gap: 10px;
  width: 100%;
  padding: 0px 5px;
  border-radius: 10px;

  // padding-bottom: 12px;

  & > p {
    font-size: 10px;
    font-weight: 400;
    color: lightgray;
    /* text-transform: uppercase; */
  }

  background: ${({ active }) => (active ? "black" : "unset")};
  border: ${({ active }) => (active ? "1px solid rgba(156, 176, 196, 0.3)" : "unset")};
  ${({ active }) =>
    !active &&
    `
      &:hover {
        // box-shadow: 0 0 8px 2px orange;
        // border: 1px solid #9CB0C4;
        background:rgba(156, 176, 196, 0.3);

      }
    `}

  &:before {
    content: ${({ notificationsNumber }) =>
      `"${
        Number(notificationsNumber ?? 0) > 0
          ? "+" + (notificationsNumber ?? 0)
          : notificationsNumber ?? 0
      }"`};

    display: ${({ notificationsNumber }) => (notificationsNumber === "0" ? "none" : "flex")};
    justify-content: center;
    align-items: center;
    width: 15px;
    height: 15px;
    border-radius: 50%;
    background: #ff9200;
    padding: 1px 0;

    font-size: ${({ notificationsNumber }) =>
      notificationsNumber !== undefined ? (notificationsNumber >= "100" ? "7px" : "8px") : ""};
    font-weight: 700;
    z-index: 99;
    position: absolute;
    left: 7px;
    top: -1px;

    padding: ${({ notificationsNumber }) => {
      const number = Number(notificationsNumber);

      if (isNaN(number)) return;

      if (number <= 99) {
        return "0px";
      } else if (number >= 100 && number <= 999) {
        return "11px";
      } else if (number >= 1000) {
        return "13px";
      }

      return "4px";
    }};
  }
`;
